export function isForeignSignupAllowed(identityType: string, allowForeignBuyers: boolean | undefined): boolean {
  return identityType !== 'cnpj' && allowForeignBuyers === true;
}
